import { Icon } from '@iconify/react';
import specOutlined from '@iconify/icons-ant-design/file-protect-outlined';
import scheduleOutlined from '@iconify/icons-ant-design/schedule-outlined';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  project: getIcon('ic_project'),
  product: getIcon('ic_product'),
  company: getIcon('ic_company'),
  earlymarket: getIcon('ic_earlymarket'),
  settings: getIcon('ic_settings'),
  admin: getIcon('ic_admin'),
  specifications: getIcon('ic_specifications'),
  schedule: getIcon('ic_schedule'),
};

const sidebarConfig = [
  // YAWN
  {
    subheader: '',
    items: [
      {
        title: 'Architect Dashboard',
        path: PATH_DASHBOARD.yawn.architectDashboard,
        icon: ICONS.dashboard,
      },
      {
        title: 'Manufacturer Dashboard',
        path: PATH_DASHBOARD.yawn.manufacturerDashboard,
        icon: ICONS.dashboard,
      },
      {
        title: 'Projects',
        path: PATH_DASHBOARD.yawn.project.list,
        icon: ICONS.project,
      },
      {
        title: 'Schedules',
        path: PATH_DASHBOARD.yawn.schedule.list,
        icon: ICONS.schedule,
      },
      ...(import.meta.env.VITE_APP_ENV_NAME !== 'prod'
        ? [
            {
              title: 'Specifications',
              path: PATH_DASHBOARD.yawn.spec.list,
              icon: ICONS.specifications,
            },
          ]
        : []),
      {
        title: 'Products',
        path: PATH_DASHBOARD.yawn.product.list,
        icon: ICONS.product,
      },
      {
        title: 'Companies',
        path: PATH_DASHBOARD.yawn.company.list,
        icon: ICONS.company,
      },
      {
        title: 'Users',
        path: PATH_DASHBOARD.yawn.user.list,
        icon: ICONS.user,
      },
      {
        title: 'Analytics',
        path: PATH_DASHBOARD.yawn.analyticsDashboard,
        icon: ICONS.analytics,
      },
      { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
      {
        title: 'Earlymarket',
        path: PATH_DASHBOARD.yawn.constructionProject.root,
        icon: ICONS.earlymarket,
      },
      {
        title: 'Settings',
        path: PATH_DASHBOARD.yawn.settings.root,
        icon: ICONS.settings,
        children: [
          { title: 'user', path: PATH_DASHBOARD.yawn.settings.user },
          {
            title: 'company',
            path: (user) => `${PATH_DASHBOARD.yawn.company.root}/${user?.company_id || '0'}/edit`,
          },
          { title: 'display', path: PATH_DASHBOARD.yawn.settings.display },
        ],
      },
      {
        title: 'Admin',
        path: PATH_DASHBOARD.yawn.admin.root,
        icon: ICONS.admin,
        children: [
          { title: 'Product mapping', path: PATH_DASHBOARD.yawn.admin.productmapping },
          { title: 'Stats', path: PATH_DASHBOARD.yawn.admin.stats },
          { title: 'Standard link', path: PATH_DASHBOARD.yawn.admin.standardLink },
        ],
      },
    ],
  },
];

export default sidebarConfig;
